import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { LogoMark } from '../LogoMark';

export default function Logo() {
  return (
    <Flex
      alignItems='center'
      flexDirection={{ base: 'row', md: 'column' }}
      justifyContent={{ base: 'flex-start', md: 'center' }}
      gap={5}
    >
      <LogoMark />
      <Flex
        alignItems={{ base: 'flex-start', md: 'center' }}
        flexDirection='column'
        justifyContent='center'
        height='100%'
      >
        <Text
          lineHeight='1'
          fontWeight='700'
          fontSize={{ base: 15, md: 20 }}
          textTransform='uppercase'
          mt={5}
        >
          International Monetary Fund
        </Text>
        <Text textTransform='uppercase' textStyle='h6' mt={0} fontWeight={500}>
          IMF Annual Report 2024
        </Text>
      </Flex>
    </Flex>
  );
}
